import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { captureGoogleAnalyticsPageview, isGoogleAnalyticsEnabled } from '@/lib/google-analytics';

export function GoogleAnalyticsPageviewTracker() {
    const router = useRouter();

    useEffect(() => {
        if (!isGoogleAnalyticsEnabled()) {
            return;
        }

        const capture = () => {
            const location = router.state.resolvedLocation ?? router.state.location;
            const search = location.searchStr ?? '';
            void captureGoogleAnalyticsPageview(location.pathname, search, document.title);
        };

        capture();

        return router.subscribe('onResolved', () => {
            capture();
        });
    }, [router]);

    return null;
}
